export const GET_MIX_START='GET_MIX_START';
export const GET_MIX_SUCCESS='GET_MIX_SUCCESS';
export const GET_MIX_FAIL='GET_MIX_FAIL';
